import {
  ESTUDIOTURNOS_SUCCESS,
  ESTUDIOTURNOS_LOADING,
  ESTUDIOTURNOS_ERROR,
  ESTUDIOTURNOS_LOGOUT,
  ESTUDIOTURNOS_SETCIRCUITORESO,
  ESTUDIOTURNOS_SETCIRCUITOTOMO,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const wsGetVerificaEstudiosQr =
  (idGrupoMedico, particular, flgVideoAtencion, osAlternativa, nextStep) =>
  (dispatch) => {
    dispatch({ type: ESTUDIOTURNOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/estudios/verificarOSQr/${idGrupoMedico}/${particular}/${flgVideoAtencion}/${osAlternativa}`
        )
        .then((resp) => {
          dispatch({
            type: ESTUDIOTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({ type: ESTUDIOTURNOS_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const wsPostTurnosEstudiosQr = (requestBody, nextStep) => (dispatch) => {
  dispatch({ type: ESTUDIOTURNOS_LOADING });
  axiosInstance().then((respuesta) => {
    respuesta
      .post(`/estudios/turnosQr`, requestBody)
      .then((resp) => {
        dispatch({
          type: ESTUDIOTURNOS_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: ESTUDIOTURNOS_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const wsPostTurnosKinesioQr = (requestBody, nextStep) => (dispatch) => {
  dispatch({ type: ESTUDIOTURNOS_LOADING });
  axiosInstance().then((respuesta) => {
    respuesta
      .post(`/estudios/turnosKinQr`, requestBody)
      .then((resp) => {
        dispatch({
          type: ESTUDIOTURNOS_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: ESTUDIOTURNOS_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const wsPostTomarTurnoKinesioQr = (requestBody) => (dispatch) => {
  dispatch({
    type: ESTUDIOTURNOS_LOADING,
  });
  axiosInstance().then((respuesta) => {
    respuesta
      .post(`/estudios/tomarTurnoKinQr`, requestBody)
      .then((res) => {
        dispatch({
          type: ESTUDIOTURNOS_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ESTUDIOTURNOS_ERROR,
          payload: error,
        });
      });
  });
};

export const wsPostTomarTurnoEstudiosQr =
  (requestBody, nextStep) => (dispatch) => {
    dispatch({ type: ESTUDIOTURNOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .post(`/estudios/tomarTurno/qr`, requestBody)
        .then((resp) => {
          dispatch({
            type: ESTUDIOTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: ESTUDIOTURNOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const setCircuitoReso = (circuitoReso) => (dispatch) => {
  dispatch({
    type: ESTUDIOTURNOS_SETCIRCUITORESO,
    payload: circuitoReso,
  });
};
export const setCircuitoTomo = (circuitoTomo) => (dispatch) => {
  dispatch({
    type: ESTUDIOTURNOS_SETCIRCUITOTOMO,
    payload: circuitoTomo,
  });
};

export const wsPostCalulaMinutos = (requestBody, nextStep) => (dispatch) => {
  dispatch({ type: ESTUDIOTURNOS_LOADING });
  axiosInstance().then((respuesta) => {
    respuesta
      .post(`/estudios/calcular_minutos`, requestBody)
      .then((resp) => {
        dispatch({
          type: ESTUDIOTURNOS_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: ESTUDIOTURNOS_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const logoutEstudiosTurnos = () => (dispatch) => {
  dispatch({ type: ESTUDIOTURNOS_LOGOUT });
};
